import get from 'lodash/get'
import every from 'lodash/every'

let instance

export class HydrationManager {
  //
  constructor (options) {
    this._hydrated = []
    this._initialized = []
    this._complete = false
    this._onHydrationComplete = get(options, 'onHydrationComplete', () => {})
  }

  setInitialized (id) {
    if (this._complete) return
    if (this._initialized.indexOf(id) === -1) {
      this._initialized.push(id)
    }
  }

  setHydrated (id) {
    if (this._complete) return
    if (this._initialized.indexOf(id) > -1) {
      this._hydrated.push(id)
      this._complete = every(this._initialized, (i) => (
        this._hydrated.indexOf(i) > -1
      ))
      if (this._complete) {
        this._onHydrationComplete()
        this._initialized = []
        this._hydrated = []
      }
    }
  }

  setComplete (bool) {
    if (this._complete !== bool) {
      this._complete = bool
      if (this._complete) {
        this._onHydrationComplete()
      }
    }
  }

  empty () {
    return this._initialized.length < 1
  }

  toContextAPI () {
    return {
      setInitialized: (id) => this.setInitialized(id),
      setComplete: (bool) => this.setComplete(bool),
      setHydrated: (id) => this.setHydrated(id),
      complete: () => this._complete,
      empty: () => this.empty(),
    }
  }
}

HydrationManager.getContextAPI = function getInstance (options) {
  instance = instance || new HydrationManager(options)
  return instance.toContextAPI()
}

export default HydrationManager
